import useBrandingDay from '@hooks/useBrandingDay'
import useIsContentForceCentered from '@hooks/useIsContentForceCentered'
import {
  desktopCenteredContentCSS,
  desktopLeftAlignedCSS,
  tabletCSS,
} from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface StyledSidebarRightPlaceholderProps {
  isContentForceCentered: boolean
}

const StyledSidebarRightPlaceholder = styled.div<StyledSidebarRightPlaceholderProps>`
  ${({ isContentForceCentered }) => css`
    grid-column: 1;
    display: none;

    ${desktopCenteredContentCSS(css`
      display: block;
    `)}

    ${desktopLeftAlignedCSS(css`
      ${isContentForceCentered &&
      css`
        display: block;
      `}
    `)}

    ${tabletCSS(css`
      display: none;
    `)}
  `}
`

interface StyledAnchorProps {
  isBrandingDayVisible: boolean
}

const StyledAnchor = styled.a<StyledAnchorProps>`
  ${({ isBrandingDayVisible }) =>
    !isBrandingDayVisible
      ? css`
          display: none;
        `
      : css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: block;
        `}
`

const SidebarRightPlaceholder: FunctionComponent = () => {
  const { isVisible, options } = useBrandingDay()
  const isContentForceCentered = useIsContentForceCentered()

  return (
    <StyledSidebarRightPlaceholder
      isContentForceCentered={isContentForceCentered}>
      {options?.clickUrl && (
        <StyledAnchor
          target="_blank"
          rel="noopener nofollow"
          href={options?.clickUrl}
          isBrandingDayVisible={isVisible}
        />
      )}
    </StyledSidebarRightPlaceholder>
  )
}

export default SidebarRightPlaceholder
